export const page = {
    methods: {
        changePage(path) {
            this.$router.push(path);
            // if (path === "/services/unwetterwarnung") {
            //     path = { name: "services-unwetterwarnung" };
            // } else if (path === "/services/e-bike-tracker") {
            //     path = { name: "services-biketrax" };
            // }
            // let feature = "";
            // if (typeof path === "object" && "name" in path) {
            //     if (path.name === "services-unwetterwarnung") {
            //         feature = "Unwetter";
            //     } else if (path.name === "services-biketrax") {
            //         feature = "EbikeTracker";
            //     }
            // }
            // if (feature !== "" && !("params" in path)) {
            //     const contracts = this.$store.state.contracts;
            //     let foundContractId = false;
            //     let featureCounter = 0;
            //     for (let key in contracts) {
            //         if (
            //             "Features" in contracts[key] &&
            //             feature in contracts[key].Features
            //         ) {
            //             if (featureCounter === 0) {
            //                 path.params = {};
            //                 path.params.contractId = key;
            //                 foundContractId = true;
            //             }
            //             featureCounter++;
            //         }
            //     }
            //     if (feature === "Unwetter") {
            //         this.$store.commit(
            //             "unwetterwarnungen/setContractsCounter",
            //             featureCounter
            //         );
            //     } else if (feature === "EbikeTracker") {
            //         this.$store.commit(
            //             "biketrax/setContractsCounter",
            //             featureCounter
            //         );
            //     }
            //     if (foundContractId) {
            //         const motivesConfig = this.$store.state.motivesConfig;
            //         let selectedMotive = Object.values(
            //             contracts[path.params.contractId].Motives
            //         )[0];
            //         let motivePath = "berater";
            //         for (let key in motivesConfig) {
            //             if (motivesConfig[key].motive === selectedMotive) {
            //                 motivePath = motivesConfig[key].path;
            //                 break;
            //             }
            //         }
            //         path.params.motive = motivePath;
            //         if (featureCounter > 1) {
            //             path.params.shouldPresentContractSwitcherModal = true;
            //         }
            //     } else if (feature !== "EbikeTracker") {
            //         this.$ionic.alertController
            //             .create({
            //                 header: "Fehler",
            //                 message:
            //                     "Es wurde leider kein Vertrag gefunden, der dieses Feature unterstützt.",
            //                 buttons: ["OK"],
            //             })
            //             .then((a) => a.present());
            //     }
            // }
            // return path ? this.$router.push(path) : false;
        },
    },
};
